<template>
  <chat-log-list-card />
</template>
<script>
import ChatLogListCard from "./components/ChatLogListCard.vue";
export default {
  components: { ChatLogListCard },
};
</script>
